<div class="text-fg flex w-full flex-col gap-5">
  <!-- Header -->
  <header class="flex items-center justify-between gap-4">
    <h1 class="m-0 font-heading text-3xl font-extrabold tracking-tight text-fg">Journal</h1>
    @if (entityConfig.showCreateButton !== false && roleAccess.isActiveSystemRole()) {
      <a uiButton [routerLink]="shellRoutes.commands('manage', entityKey, 'new')">
        <ng-icon name="lucidePlus" size="16" />
        <span>New Operation</span>
      </a>
    }
  </header>

  <!-- Overview Section -->
  <section class="overflow-hidden rounded-lg border border-border bg-card">
    <button
      type="button"
      class="flex w-full cursor-pointer items-center justify-between border-0 bg-transparent px-5 py-3.5 text-sm font-bold uppercase tracking-wide text-fg transition-colors hover:bg-surface-muted"
      (click)="toggleOverview()"
    >
      <span>Overview</span>
      <ng-icon [name]="overviewExpanded() ? 'lucideChevronUp' : 'lucideChevronDown'" size="16" />
    </button>

    @if (overviewExpanded()) {
      <div class="px-5 pb-5">
        @if (statsLoading()) {
          <div class="flex items-center justify-center gap-2 py-4 text-muted">
            <ui-spinner size="sm" />
            <span class="text-xs">Loading stats...</span>
          </div>
        } @else if (statsError(); as err) {
          <div class="flex items-center gap-3 rounded-md bg-danger-bg p-3 text-sm text-danger-fg">
            <span>{{ err }}</span>
            <button type="button" uiButton variant="outline" size="sm" (click)="loadStats()">
              <ng-icon name="lucideRefreshCw" size="14" />
              <span>Retry</span>
            </button>
          </div>
        } @else if (stats(); as s) {
          <!-- KPI Cards -->
          <div class="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-[repeat(auto-fill,minmax(140px,1fr))]">
            <div class="flex flex-col items-center rounded-lg border border-border bg-surface-muted px-2.5 py-3.5 text-center">
              <span class="text-2xl font-extrabold leading-tight text-fg">{{ s.total_entries | number:'1.0-0' }}</span>
              <span class="mt-1 text-[0.7rem] font-semibold uppercase tracking-wide text-muted">Total Entries</span>
            </div>
            <div class="flex flex-col items-center rounded-lg border border-border bg-surface-muted px-2.5 py-3.5 text-center">
              <span class="text-2xl font-extrabold leading-tight text-fg">{{ s.recent_entries | number:'1.0-0' }}</span>
              <span class="mt-1 text-[0.7rem] font-semibold uppercase tracking-wide text-muted">Last 30 Days</span>
            </div>
            @for (entry of s.entries_by_type; track entry.event_type) {
              <div class="flex flex-col items-center rounded-lg border border-border bg-surface-muted px-2.5 py-3.5 text-center">
                <span class="text-2xl font-extrabold leading-tight text-fg">{{ entry.count | number:'1.0-0' }}</span>
                <span class="mt-1 text-[0.7rem] font-semibold uppercase tracking-wide text-muted">
                  <ui-badge [variant]="getEventTypeVariant(entry.event_type)">
                    {{ getEventTypeLabel(entry.event_type) }}
                  </ui-badge>
                </span>
              </div>
            }
          </div>

          <!-- Currency Totals -->
          @if (getCurrencyCodes().length > 0) {
            <div>
              <h4 class="m-0 mb-2.5 text-xs font-bold uppercase tracking-wide text-muted">Totals by Currency</h4>
              <div class="grid grid-cols-1 gap-2.5 sm:grid-cols-[repeat(auto-fill,minmax(200px,1fr))]">
                @for (code of getCurrencyCodes(); track code) {
                  <div class="flex items-center gap-3 rounded-md border border-border bg-surface-muted px-3.5 py-2.5">
                    <span class="min-w-9 font-mono text-sm font-bold text-fg">{{ code }}</span>
                    <div class="flex flex-1 flex-col gap-0.5">
                      <div class="flex justify-between text-xs">
                        <span class="font-medium text-muted">Debits</span>
                        <span class="font-mono font-semibold text-danger-fg">{{ s.total_by_currency[code].debit | number:'1.2-4' }}</span>
                      </div>
                      <div class="flex justify-between text-xs">
                        <span class="font-medium text-muted">Credits</span>
                        <span class="font-mono font-semibold text-success-fg">{{ s.total_by_currency[code].credit | number:'1.2-4' }}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </section>

  <!-- Journal Entries List -->
  <section class="w-full">
    <lib-dynamic-list
      [listPath]="listPath"
      (rowSelect)="onRowSelect($event)"
    />
  </section>
</div>
